const color = {
    background: '#f8f8f8',
    partLine: '#e5e5e5',
    master: '#7370aa',
    second: '#8d77df',
    report_lowest: '#aa8ee4',
    report_lower: '#00c1e4',
    report_stand: '#a7cb40',
    report_higher: '#fbc13d',
    report_highest: '#f74142',
    report_sufficient: '#3ea42c',
    report_orange_highest:'#F7931E',
    report_claret_sufficient: '#AC2700'
};

module.exports = {
    color,
};




// WEBPACK FOOTER //
// ./src/report/UI.js